import { Snackbar, Alert } from '@mui/material';

export enum NotificationSeverity {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
};

export interface NotificationProps {
  open: boolean;
  message: string;
  severity: NotificationSeverity;
  duration: number;
  onClose: () => void;
}

const Notification = ({ open, message, severity, duration, onClose }: NotificationProps) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={duration}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
